"use strict";

/**
 * Desktop under video banner
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  // refresh banners after new related videos loaded
  document.addEventListener('flix:additional-related', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled && FlixUtils.isDesktop() // desktop only
    && !!document.querySelector('#ads-under-video'); // video page
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    FlixUtils.renderBannerAd(getZoneId(), document.querySelector('#ads-under-video'), 'eas6a97888e38', 'ad_error_under_video');
  }
  ;
  function getZoneId() {
    return Flix.isTna() ? '5632512' : '5632476';
  }
})();